import request from ".";

export const schoolApi = {
  getSchool: (school: string) =>
    request.post(`Academics/getAcademicsByUrl?UniqueUrl=${school}`),
  getSchoolFacilityByUrl: (url: string) =>
    request.post(
      `AcademicsFacilities/getAcademicsFacilitiesByUrlNew?UniqueUrl=${url}`
    ),
};
